import {useContext} from 'react'
import {FiltersContext} from './FiltersContext'

export const useFilters = () => {
  const contextInstance = useContext(FiltersContext)
  if (!contextInstance) throw new Error('Cannot call useFilters() outside of <FiltersProvider>')
  return contextInstance
}
